import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Link as BaseLink, LinkProps } from 'react-router';

const StyledBaseLink = styled(BaseLink)(({ theme }) => ({
    color: theme.palette.hint
}));

export const Link: React.FC<React.PropsWithChildren<LinkProps>> = ({ children, ...props }) => (
    <StyledBaseLink {...props}>{children}</StyledBaseLink>
);
